__turbopack_context__.v({
  "contact": "BlockFoodServiceContactForm-module-scss-module__FZ_xmW__contact",
  "contactInner": "BlockFoodServiceContactForm-module-scss-module__FZ_xmW__contactInner",
  "flushBottom": "BlockFoodServiceContactForm-module-scss-module__FZ_xmW__flushBottom",
  "flushTop": "BlockFoodServiceContactForm-module-scss-module__FZ_xmW__flushTop",
  "headline": "BlockFoodServiceContactForm-module-scss-module__FZ_xmW__headline",
});
